import { Button, Tooltip, useToggle } from '@factorialco/deprecated-design-system'

interface Props {
  tooltipLabel: string
  onClick: () => void
}

const InformationButton = ({ tooltipLabel, onClick }: Props) => {
  const [open, toggle] = useToggle(false)

  return (
    <Tooltip.Alt attachment="bottom center" open={open} toggle={toggle} label={tooltipLabel}>
      <Button
        type="secondary"
        aria-label="Information button"
        onClick={onClick}
        iconName="info-circle-line"
      />
    </Tooltip.Alt>
  )
}

export default InformationButton
